import styled from '@emotion/styled';
import './App.css';
import { Home } from './Pages/Home';
import Dashboard from './Pages/Dashboard';
import {
  Routes,
  Route,
  Outlet,
  Link,
  useMatch,
  useResolvedPath,
  BrowserRouter
} from "react-router-dom";

const Wrapper = styled.div`
  background-color: #000029;
  backdrop-filter: blur(50px) opacity(0.5);
`
const WrapperNAN = styled(Wrapper)`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

`
function Layout() {
  return (
    <Wrapper>
      <Outlet />
    </Wrapper>
  )
}
function NoMatch() {
  return (
    <WrapperNAN>
      <h2 style={{color: '#fff'}}>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </WrapperNAN>
  );
}
function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
    </BrowserRouter>
  );
}

export default App;